import { TmrBaseResource } from 'stylewhere/api'

export class Pallets extends TmrBaseResource {
  static endpoint = 'api/v1/pallets'
}
